import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InitialsService {

    constructor() {
    }

    formatInitials(name: string) {
        if (name.indexOf(' ') > 0) {
            return (name[0] + name[name.indexOf(' ') + 1]).toUpperCase();
        } else if (name.length > 3) {
            return name.substr(0, 3).toUpperCase();
        } else {
            return name.toUpperCase();
        }
    }
}
